export const CHECKOUT_SE_CAR = '/se/car';
export const CHECKOUT_SE_CONDO = '/se/condo';
export const CHECKOUT_FR_CONDO = '/fr/condo';
export const CHECKOUT_FR_PET = '/fr/dog'; // TODO: Change to pet when we're using insuranceType instead of subType
